import React from "react";
import Icon from "./Icon";

// Phone bottom sheet: title, optional content, a list of actions and Cancel.
// items: [{ label, icon, danger, showChevron, disabled, onClick }]
const ActionSheet = ({ title, subtitle, items, onClose, children }) => (
  <React.Fragment>
    <div className="row-sheet-overlay" onClick={onClose} />
    <div className="row-sheet" role="dialog" aria-label={title || "Actions"}>
      <div className="row-sheet-handle" />
      {title && (
        <div className="row-sheet-header">
          <div className="row-sheet-title">{title}</div>
          {subtitle && <div className="row-sheet-subtitle">{subtitle}</div>}
        </div>
      )}

      {children}

      <div className="row-sheet-actions">
        {(items || []).map((item, index) => (
          <button
            key={index}
            type="button"
            disabled={item.disabled}
            className={"row-sheet-action" + (item.danger ? " is-danger" : "")}
            onClick={() => {
              onClose();
              item.onClick();
            }}
          >
            {item.icon && (
              <span className="row-sheet-action-icon">
                <Icon type={item.icon} />
              </span>
            )}
            <span className="row-sheet-action-label">{item.label}</span>
            {item.showChevron && (
              <span className="row-sheet-action-chevron">
                <Icon type="rightarrow" />
              </span>
            )}
          </button>
        ))}
      </div>

      <button type="button" className="row-sheet-cancel" onClick={onClose}>
        Cancel
      </button>
    </div>
  </React.Fragment>
);

export default ActionSheet;
